import React, { useState } from 'react';
import {
  ContentColors,
  Flex,
  HorizontalSpacing,
  IconCircleDeleteFilled,
  Input,
  NaviIconSearch,
  TextButton,
} from '@banhala/ui-kit';
import { useFilterListAtom } from '../Provider/filterList/useFilterListAtom';
import { useLogAnalyticsEvent } from '../../../../../hooks/useLogAnalyticsEvent';
import type { AnyObject, SetState } from '../../../../../types';
import type { TextInputProps } from 'react-native';

export const InputKeywordSearch: React.FC<{
  inputValue: string;
  setInputValue: SetState<string>;
  placeholder?: string;
  logging: AnyObject;
  closeFilterList: VoidFunction;
}> = ({ inputValue, setInputValue, placeholder, logging, closeFilterList }) => {
  const [focused, setFocused] = useState(false);

  const { clearSearchKeyword, setSearchKeyword } = useFilterListAtom();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const handleSubmitEditing: TextInputProps['onSubmitEditing'] = ({
    nativeEvent,
  }) => {
    const { text } = nativeEvent;
    logAnalyticsEvent({
      name: 'SEARCH_KEYWORD',
      ably_only_log: logging.analytics.ably_only_log,
      analytics: {
        ...logging.analytics.analytics,
        SEARCH_KEYWORD: text,
      },
    });
    setSearchKeyword(text);
  };
  const handleCancleInput = () => {
    closeFilterList();
    clearSearchKeyword();
    setInputValue('');
  };

  return (
    <Flex.Row padding={{ bottom: 12, left: 16 }}>
      <Flex.Row
        flex={1}
        backgroundColor={'gray20'}
        borderRadius={8}
        padding={{ left: 10 }}
        alignItems={'center'}
        height={36}
      >
        <NaviIconSearch
          width={20}
          height={20}
          fill={ContentColors.content_secondary}
        />
        <HorizontalSpacing size={4} />
        <Input
          style={{
            flex: 1,
          }}
          value={inputValue}
          onChangeText={setInputValue}
          onSubmitEditing={handleSubmitEditing}
          fontVariant={'body2'}
          placeholder={placeholder}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          autoFocus
        />
        {focused && (
          <Flex
            width={40}
            height={36}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <IconCircleDeleteFilled
              width={20}
              height={20}
              fill={ContentColors.content_tertiary}
            />
          </Flex>
        )}
      </Flex.Row>
      <TextButton size={'medium'} color={'gray'} onPress={handleCancleInput}>
        취소
      </TextButton>
    </Flex.Row>
  );
};

